
export class ElementModel {
  elementId: number = 0;
  componentId: number = 0;
  maintenanceRoutineId: number = 0;
  code: number = 0;
  name: string = '';
  createDate: Date = new Date();
  userNameCreate: string = '';
  updateDate: Date | null = null;
  userNameUpdate: string | null = null;
}